import { t } from 'i18next';
import { CSSProperties, forwardRef } from 'react';

import { PartNumberFormField } from 'bom/components';
import Textarea from 'core/components//Textarea';
import { Autocomplete } from 'core/components/Autocomplete';
import CheckboxInput from 'core/components/CheckboxInput';
import DateInput from 'core/components/DateInput';
import { Input } from 'core/components/Input';
import NumberInput from 'core/components/NumberInput';
import RadioGroupInput from 'core/components/RadioGroupInput';
import Select from 'core/components/Select';
import { SwitchInput } from 'core/components/SwitchInput';
import TextEditor from 'core/components/TextEditor';
import { InputType } from 'core/enums';
import { PartBomFormField } from 'partBoms/components/PartBomFormField';

import { FieldWrapper } from './style';

interface IProps {
  name?: string;
  type: InputType;
  fullWidth?: boolean;
  inputProps?: Record<string, any>;
  wrapperStyle?: CSSProperties;
  hidden?: boolean;
}

const getFieldByType = (ref = null, name, type, inputProps) => {
  switch (type) {
    case InputType.CHECKBOX:
      return <CheckboxInput name={name} {...inputProps} />;
    case InputType.SWITCH:
      return <SwitchInput name={name} {...inputProps} />;
    case InputType.TEXT_EDITOR:
      return <TextEditor name={name} {...inputProps} />;
    case InputType.TEXT_INPUT:
      return <Input name={name} {...inputProps} type="text" />;
    case InputType.TEXTAREA:
      return <Textarea name={name} {...inputProps} />;
    case InputType.NUMBER_INPUT:
      return <NumberInput name={name} {...inputProps} />;
    case InputType.SELECT:
      return <Select name={name} {...inputProps} />;
    case InputType.AUTOCOMPLETE:
      return <Autocomplete ref={ref} name={name} {...inputProps} />;
    case InputType.DATE_INPUT:
      return <DateInput name={name} {...inputProps} />;
    case InputType.RADIO_GROUP:
      return <RadioGroupInput name={name} {...inputProps} />;
    case InputType.PART_AUTOCOMPLETE:
      return <PartNumberFormField name={name} {...inputProps} />;
    case InputType.PART_BOM_AUTOCOMPLETE:
      return <PartBomFormField name={name} {...inputProps} />;
    default:
      throw new Error(t('errorUnknownInputType', { type }));
  }
};

const FormFieldView = forwardRef(function FormFieldView(
  { name, type, fullWidth = true, inputProps, wrapperStyle, hidden = false }: IProps,
  ref
) {
  if (hidden) {
    return null;
  }

  return (
    <FieldWrapper fullWidth={fullWidth} style={wrapperStyle}>
      {getFieldByType(ref, name, type, inputProps)}
    </FieldWrapper>
  );
});

export default FormFieldView;
